import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import * as Plot from "@observablehq/plot";
import { PlotDefinition } from 'src/modules/enaio/shared/PlotDefinition';
import { PlotReducer } from 'src/modules/enaio/shared/PlotReducer';
import { PlotResult } from 'src/modules/enaio/shared/PlotResult';
import { PlotType } from 'src/modules/enaio/shared/PlotType';
import { Utils } from 'src/modules/utils/shared/utils';

@Component({
  selector: 'app-plot',
  templateUrl: './plot.component.html',
  styleUrl: './plot.component.scss'
})
export class PlotComponent {

    @Input()
    def: PlotDefinition;

    @Input()
    data: PlotResult;

    height = 1000;
    width = 1000;

    @ViewChild("plotDiv", {read: ElementRef}) plotDiv: ElementRef;
    @ViewChild("xAxisDiv", {read: ElementRef}) xAxisDiv: ElementRef;

    public generate(def: PlotDefinition, data: PlotResult): void {
        this.def = def;
        this.data = data;
        let options: any = !Utils.isNoe(def.xAxis.field2) ? {x1: row => row[0], x2: row => row[2], y: row => row[1]} : {x: row => row[0], y: row => row[1]};
        if (def.yAxis.reducer == PlotReducer.count) {
            options = Plot.groupX({ y: "count" }, { x: options.x });
        }
        if (!Utils.isNoe(def.colorBy)) {
            options.fill = row => row[3];
        }
        options.tip = row => row[0];
        options.opacity = def.opacity;

        let marks: Plot.Markish[] = [];
        switch (def.type) {
            case  PlotType.line:
                marks = [...marks, Plot.line(this.data.rows, options as Plot.LineOptions)];
                break;
            case  PlotType.area:
                options.x1 = options.x;
                options.y1 = options.y;
                delete options.x;
                delete options.y;
                marks = [...marks, Plot.area(this.data.rows, options as Plot.AreaOptions)];
                break;
            case  PlotType.barX:
                marks = [...marks, Plot.barX(this.data.rows, options as Plot.BarXOptions)];
                break;
            case  PlotType.barY:
                marks = [...marks, Plot.barY(this.data.rows, options as Plot.BarYOptions)];
                break;
            case  PlotType.dot:
                marks = [...marks, Plot.dot(this.data.rows, options as Plot.DotOptions)];
                break;
            case  PlotType.tickX:
                marks = [...marks, Plot.tickX(this.data.rows, options as Plot.TickXOptions)];
                break;
            case  PlotType.tickY:
                marks = [...marks, Plot.tickY(this.data.rows, options as Plot.TickXOptions)];
                break;
            case  PlotType.pie:
                marks = [...marks, Plot.tickY(this.data.rows, options as Plot.TickXOptions)];
                break;
        }
        let uniqueLabels = Utils.arrayGetUnique(this.data.rows.map(row => row[1] as string));
        let maxLabelWidth = this.calculateMaxLabelWidth(uniqueLabels);
        let numLabels = uniqueLabels.length;
        //marks = [Plot.ruleY([0]), ...marks]; //TODO: Durchgehende Linie für Achse. Wird aktuell oben angezeigt. Warum? TODO
        let o = {
           // figure: true, //TODO: Sollte dazu führen dass figure immer generiert wird und DOM konsistent bleibt
            x: {
                grid: true
            },
            y: {
                grid: true
            },
           // TODO Ändert DOM Struktur - Rauslösen von X Achse klappt dann nicht mehr
            /*
            color: !Utils.isNoe(def.colorBy) ? {
                legend: true
            } : null,
            */height: def.type == PlotType.barX && numLabels > 50 ? numLabels * 20 : this.height - 10,
            width: this.plotDiv.nativeElement.clientWidth * 0.8 + 20,
            marks,
            marginLeft: Math.min(200, maxLabelWidth) //TODO. Das muss dynamisch berechnet werden, um verschieden lange Achsenbeschriftungen zu unterstützen
        };
        console.log(o);
        let plot = Plot.plot(o);
        this.plotDiv.nativeElement.innerHTML = "";
        this.plotDiv.nativeElement.appendChild(plot);
        let plot2 = Plot.plot(o);
        this.xAxisDiv.nativeElement.innerHTML = "";
        this.xAxisDiv.nativeElement.appendChild(plot2);
        this.adjustXAxis(this.plotDiv.nativeElement as HTMLElement, this.xAxisDiv.nativeElement as HTMLElement);

    }

    adjustXAxis(plot: HTMLElement, e: HTMLElement): void {
        for (let gElement of Array.from(e.querySelectorAll("g"))) {
            if (!gElement.getAttribute("aria-label").includes("x-axis")) {
                gElement.remove();
            }
        }

        for (let gElement of Array.from(plot.querySelectorAll("g"))) {
            if (gElement.getAttribute("aria-label").includes("x-axis")) {
                gElement.remove();
            }
        }

        const xAxisGroup = Array.from(e.querySelectorAll('g[aria-label*="x-axis"'));
        const textElements = Utils.arrayExplode(xAxisGroup, g => Array.from(g.querySelectorAll('*')));

        const translateYValues = textElements.map((textElement) => {
            const transform = textElement.getAttribute('transform');
            if (transform == null) {
                return 999999999;
            }
            const translateMatch = /translate\(\d+(\.\d+)?,(\d+(\.\d+)?)\)/.exec(transform);
            return translateMatch ? parseFloat(translateMatch[2]) : 0;
        });

        const minYValue = Math.min(...translateYValues);

        for (let textElement of textElements) {
            const transform = textElement.getAttribute('transform');
            const translateMatch = /translate\((\d+(\.\d+)?),(\d+(\.\d+)?)\)/.exec(transform);
            if (translateMatch) {
            const x = parseFloat(translateMatch[1]);
            const y = parseFloat(translateMatch[3]);
            const newY = y - minYValue;
            textElement.setAttribute("transform", "translate(" + x + "," + newY + ")");
            }
        }
    }

    calculateMaxLabelWidth(labels: string[]): number {
        // Erstelle ein temporäres Element zum Messen der Labelbreiten
        const tempElement = document.createElement('div');
        tempElement.style.position = 'absolute';
        tempElement.style.visibility = 'hidden';
        tempElement.style.whiteSpace = 'nowrap';
        document.body.appendChild(tempElement);

        let maxWidth = 0;
        labels.forEach(label => {
          tempElement.innerText = label;
          const width = tempElement.offsetWidth;
          if (width > maxWidth) {
            maxWidth = width;
          }
        });

        document.body.removeChild(tempElement);
        return maxWidth;
      }

}
